import { Routes } from '@angular/router';
import { LoginComponent } from './../domains/login/login.component';
import { PrincipalComponent } from './../domains/principal/principal.component';
import { IndustriaYComercioComponent } from '../domains/industriaycomercio/industriaycomercio.component';
import { RetencionICAComponent } from '../domains/retencionica/retencionica.component';
import { PagarICAComponent } from '../domains/pagar_ica/pagar_ica.component';
import { PagarReteICAComponent } from '../domains/pagar_reteica/pagar_reteica.component';
import { FirmarICAComponent } from '../domains/firmar_ica/firmar_ica.component';
import { FirmarReteICAComponent } from '../domains/firmar_reteica/firmar_reteica.component';

export const routes: Routes = [
    { path: 'login', component: LoginComponent },
    { path: 'principal', component: PrincipalComponent },
    { path: 'industria_y_comercio', component: IndustriaYComercioComponent },
    { path: 'retencion_ica', component: RetencionICAComponent },
    { path: 'por_pagar_ica', component: PagarICAComponent },
    { path: 'por_pagar_reteica', component: PagarReteICAComponent },
    { path: 'por_firmar_ica', component: FirmarICAComponent },
    { path: 'por_firmar_reteica', component: FirmarReteICAComponent },
    { path: '**', redirectTo: '/login', pathMatch: 'full' }
];